export const isEmpty = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return value === 0 || isNaN(value);
  }

  if (Array.isArray(value) || typeof value === 'string') {
    return value.length === 0;
  }

  return value === null || value === undefined || Object.keys(value).length === 0;
};
